import client from './client';

// StockEasy 카피 트레이딩 상태 조회
export const getStrategyStatus = async () => {
  const response = await client.get('/strategy/status');
  return response.data;
};

// 자동매매 설정
export const setAutoTrade = async (enabled, accountId = null) => {
  const params = new URLSearchParams();
  params.append('enabled', enabled);
  if (accountId) params.append('account_id', accountId);

  const response = await client.post(`/strategy/auto-trade?${params}`);
  return response.data;
};

// StockEasy vs 우리 보유종목 비교
export const getComparison = async () => {
  const response = await client.get('/strategy/comparison');
  return response.data;
};

// 데이터 수집 상태 조회 (인증 불필요)
export const getCollectState = async () => {
  const response = await client.get('/strategy/collect-state');
  return response.data;
};

// 수동 StockEasy 체크
export const manualCheck = async () => {
  const response = await client.post('/strategy/manual-check');
  return response.data;
};
